<div class="flex justify-content-between align-items-center p-3">
    <!-- Logo -->
    <div class="h-full flex align-items-center pl-1">

        <!-- Menu ouvert -->
        @if (appService.menuOpen) {

        <div class="h-3rem py-1" (click)="onClickLogo()">
            <img class="h-full" src="{{ appService.logoSrc }}" alt="Logo" />
        </div>

        <!-- Bouton pour fermer le menu -->
        <p-button type="button" icon="pi pi-angle-left" size="large" class="ml-3" [rounded]="true" [text]="true"
            (click)="appService.toggleMenu()"></p-button>

        <!-- Menu fermé -->
        } @else {

        <div class="h-3rem py-1" (click)="onClickLogo()">
            <img class="h-full" src="assets/images/big-icon.png" alt="Logo" />
        </div>

        <!-- Bouton pour ouvrir le menu -->
        <p-button type="button" icon="pi pi-angle-right" size="large" class="ml-3" [rounded]="true" [text]="true"
            (click)="appService.toggleMenu()"></p-button>
        }

    </div>

    <div class="flex align-items-center gap-3">
        @if (!!appService.user?.simulatedProfile) {
        <p-message severity="warn" [closable]="true" (onClose)="onStopProfileSimulation()">
            Vous êtes en train de simuler le rôle :
            <strong>{{ appService.user!.simulatedProfile!.label }}</strong>
        </p-message>
        } @else if (appService.selectedClient?.subscription?.package?.code === Packages.Trial) {
        <!-- Indicateur de période d'essai -->
        <div class="border-1 border-round-3xl px-3 py-2" [ngClass]="appService.selectedClient?.subscription!.remainingDays > 7 ?
            'bg-primary-50 text-primary-500' :
            'bg-red-50 text-red-500'">
            <i class="fa-solid fa-hourglass-half mr-3"></i>
            <span class="flex-grow-1">Essai gratuit : {{ appService.selectedClient?.subscription!.remainingDaysLabel
                }}</span>
        </div>
        <p-button label="S'abonner" [rounded]="true" [raised]="true"
            [routerLink]="appService.clientUrl('/settings/client/subscription')"></p-button>
        }
    </div>

    <!-- Éléments du menu -->
    <div class="flex align-items-center">

        @if (!!appService.selectedClient && appService.selectedClient.logo) {
        <!-- Logo de la société actuelle -->
        <!-- <img class="h-3rem" [src]="appService.selectedClient.logo" alt="Logo" /> -->
        }

        @if (!!appService.selectedClient) {
        @if (!!appService.selectedClient.avatar) {
        <!-- Avatar de la société actuelle -->
        <p-avatar [image]="appService.selectedClient.avatar" shape="circle" />
        } @else {
        <p-avatar [label]="appService.selectedClient.commercialName.toUpperCase()[0]" shape="circle" />
        }
        <!-- Bouton avec nom de la société, pour afficher la liste des organisations -->
        <p-button type="button" [label]="appService.selectedClient.commercialName" [text]="true"
            (click)="onClickOrganizationSelector()"></p-button>
        }

        @if (!!appService.selectedClient) {
        <!-- Lien vers les paramètres -->
        <a [routerLink]="appService.clientUrl('/settings')" class="mr-2"><p-button icon="pi pi-cog" [rounded]="true" [text]="true"></p-button></a>
        }

        @if (appService.user?.canViewMonitoring) {
        <!-- Lien vers le moniteur de supervision technique -->
        <a routerLink="/monitoring" class="mr-2"><p-button icon="pi pi-desktop" [rounded]="true"
                [text]="true"></p-button></a>
        }

        <!-- Avatar de l'utilisateur -->
        <p-avatar image="{{appService.user?.avatar}}" label="{{appService.user?.avatarLabel}}"
            [style]="{ 'background-color': appService.user?.avatarLabelColor, color: '#ffffff' }" class="ml-2"
            size="large" shape="circle"></p-avatar>

        <!-- Nom et menu utilisateur -->
        <p-button type="button" [label]="appService.user?.fullName!" [text]="true" icon="pi pi-angle-down"
            iconPos="right" (click)="userMenu.toggle($event)"></p-button>

        <!-- Changement de thème -->
        @if (appService.user?.isStaff) {
        <p-button icon="pi {{ appService.switchThemeIcon }}" [rounded]="true" [text]="true"
            (click)="onClickTheme()"></p-button>
        }

        @if (!!appService.selectedClient && appService.selectedClient.hasFeature(Features.AiAgent)) {
        <!-- Assistant IA -->
        <p-button type="button" icon="bi bi-ai-sparkles-solo" pTooltip="Assistant IA" [text]="true" [rounded]="true"
            severity="help" [outlined]="assistantPanelService.open || assistantPanelService.fullPage"
            (onClick)="onClickAssistant()"></p-button>
        }
    </div>
</div>

<p-menu #userMenu [popup]="true" [model]="userMenuItems"></p-menu>